import React, { useState, useEffect } from "react";
import axios from "../api/api";

const LocationSelector = ({ onChange }) => {
    const [provinces, setProvinces] = useState([]);
    const [districts, setDistricts] = useState([]);
    const [wards, setWards] = useState([]);

    const [selectedProvince, setSelectedProvince] = useState("");
    const [selectedDistrict, setSelectedDistrict] = useState("");
    const [selectedWard, setSelectedWard] = useState("");

    // Fetch danh sách tỉnh
    useEffect(() => {
        const fetchProvinces = async () => {
            try {
                const response = await axios.get("/locations/provinces");
                setProvinces(response.data);
            } catch (error) {
                console.error("Error fetching provinces:", error);
            }
        };
        fetchProvinces();
    }, []);

    // Fetch danh sách quận khi chọn tỉnh
    useEffect(() => {
        if (selectedProvince) {
            const fetchDistricts = async () => {
                try {
                    const response = await axios.get(
                        `/locations/provinces/${selectedProvince}/districts`
                    );
                    setDistricts(response.data);
                    setWards([]);
                    setSelectedDistrict("");
                    setSelectedWard("");
                } catch (error) {
                    console.error("Error fetching districts:", error);
                }
            };
            fetchDistricts();
        }
    }, [selectedProvince]);

    // Fetch danh sách xã khi chọn quận
    useEffect(() => {
        if (selectedDistrict) {
            const fetchWards = async () => {
                try {
                    const response = await axios.get(
                        `/locations/districts/${selectedDistrict}/wards`
                    );
                    setWards(response.data);
                    setSelectedWard("");
                } catch (error) {
                    console.error("Error fetching wards:", error);
                }
            };
            fetchWards();
        }
    }, [selectedDistrict]);

    // Xử lý thay đổi giá trị
    const handleProvinceChange = (e) => {
        const provinceId = e.target.value;
        setSelectedProvince(provinceId);
        onChange({ provinceId, districtId: "", wardId: "" });
    };

    const handleDistrictChange = (e) => {
        const districtId = e.target.value;
        setSelectedDistrict(districtId);
        onChange({ provinceId: selectedProvince, districtId, wardId: "" });
    };

    const handleWardChange = (e) => {
        const wardId = e.target.value;
        setSelectedWard(wardId);
        onChange({ provinceId: selectedProvince, districtId: selectedDistrict, wardId });
    };

    return (
        <div>
            <div className="form-group">
                <label>Tỉnh/Thành phố</label>
                <select
                    className="form-control"
                    value={selectedProvince}
                    onChange={handleProvinceChange}
                >
                    <option value="">Chọn tỉnh/thành phố</option>
                    {provinces.map((province) => (
                        <option key={province._id} value={province._id}>
                            {province.provinceName}
                        </option>
                    ))}
                </select>
            </div>

            <div className="form-group">
                <label>Quận/Huyện</label>
                <select
                    className="form-control"
                    value={selectedDistrict}
                    onChange={handleDistrictChange}
                    disabled={!selectedProvince}
                >
                    <option value="">Chọn quận/huyện</option>
                    {districts.map((district) => (
                        <option key={district._id} value={district._id}>
                            {district.districtName}
                        </option>
                    ))}
                </select>
            </div>

            <div className="form-group">
                <label>Xã/Phường</label>
                <select
                    className="form-control"
                    value={selectedWard}
                    onChange={handleWardChange}
                    disabled={!selectedDistrict}
                >
                    <option value="">Chọn xã/phường</option>
                    {wards.map((ward) => (
                        <option key={ward._id} value={ward._id}>
                            {ward.wardName}
                        </option>
                    ))}
                </select>
            </div>
        </div>
    );
};

export default LocationSelector;
